/**
 * Get initials from a full name (e.g., "John Smith" -> "JS")
 */
export function getInitials(name) {
    return name
        .split(' ')
        .map(n => n[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();
}
